import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { bidService } from '../services/bidService';
import type { RootState } from '../store';
import { BidCard } from '../components/BidCard';
import { BidStatus } from '../types';

export function HistoryPage() {
  const user = useSelector((s: RootState) => s.auth.user);
  const [resendBusyId, setResendBusyId] = useState<string | null>(null);

  const { data, isLoading, refetch } = useQuery({
    queryKey: ['bids', 'created'],
    queryFn: () => bidService.getBids('created'),
  });

  const created = data ?? [];
  const ended = created.filter((b) => b.status === BidStatus.ENDED);

  const onResendReport = async (bidId: string) => {
    setResendBusyId(bidId);
    try {
      await bidService.resendEndedBidReport(bidId);
      window.alert('The bid report has been sent to your email.');
    } catch (e) {
      window.alert(e instanceof Error ? e.message : 'Could not resend the report.');
    } finally {
      setResendBusyId(null);
    }
  };

  return (
    <div>
      <h1 className="text-xl font-black text-slate-900 mb-6">History</h1>
      {isLoading ? (
        <p className="text-slate-500">Loading...</p>
      ) : created.length === 0 ? (
        <p className="text-slate-400 text-sm italic">You have not created any bid.</p>
      ) : ended.length === 0 ? (
        <p className="text-slate-400 text-sm italic">No ended auctions yet.</p>
      ) : (
        ended.map((b) => (
          <BidCard
            key={b.id}
            bid={b}
            currentUserId={user?.id}
            onUpcomingExpire={refetch}
            showResendReport
            returnTo="/history"
            resendReportLoading={resendBusyId === b.id}
            onResendReport={() => void onResendReport(b.id)}
          />
        ))
      )}
    </div>
  );
}
